import MuiImageList, { type ImageListProps } from "@mui/material/ImageList";
import MuiImageListItem, { type ImageListItemProps } from "@mui/material/ImageListItem";
import MuiImageListItemBar, { type ImageListItemBarProps } from "@mui/material/ImageListItemBar";

export type { ImageListProps, ImageListItemProps, ImageListItemBarProps };

export function ImageList(props: ImageListProps) {
  return <MuiImageList {...props} />;
}

export function ImageListItem(props: ImageListItemProps) {
  return <MuiImageListItem {...props} />;
}

export function ImageListItemBar(props: ImageListItemBarProps) {
  return <MuiImageListItemBar {...props} />;
}
